export enum RolesEnum {
  Admin = 1,
  Operations = 2,
  DRO = 3,
  Practitioner = 4,
  CorporateAdmin = 5,
  CollegeAdmin = 6,
  PrimaryContact = 7,
  CorpAdminDelegate = 8,
  CollegeAdminDelegate = 9,
  SMC = 10,
  KeyCompanyContact = 11,
  Client = 15,
  KeyCompanyContactDelegate = 16,
  Collaborator = 17,
}

export enum DelegateRolesEnum {
  CorpAdminDelegate = RolesEnum.CorpAdminDelegate,
  CollegeAdminDelegate = RolesEnum.CollegeAdminDelegate,
  KeyCompanyContactDelegate = RolesEnum.KeyCompanyContactDelegate,
}

export const AllInternalRoles = [RolesEnum.Admin, RolesEnum.Operations, RolesEnum.DRO];

export const AllExternalRoles = [
  RolesEnum.CollegeAdmin,
  RolesEnum.CollegeAdminDelegate,
  RolesEnum.CorpAdminDelegate,
  RolesEnum.CorporateAdmin,
  RolesEnum.KeyCompanyContact,
  RolesEnum.KeyCompanyContactDelegate,
  RolesEnum.Practitioner,
  RolesEnum.PrimaryContact,
  RolesEnum.Client,
];

export const AllRoles = AllInternalRoles.concat(AllExternalRoles);

export const ALL_ROLES: Record<RolesEnum, string> = {
  [RolesEnum.Collaborator]: "Collaborator",
  [RolesEnum.Admin]: "Admin",
  [RolesEnum.Operations]: "Operations",
  [RolesEnum.DRO]: "DRO",
  [RolesEnum.Practitioner]: "Practitioner",
  [RolesEnum.CorporateAdmin]: "Corporate Admin",
  [RolesEnum.CollegeAdmin]: "College Admin",
  [RolesEnum.PrimaryContact]: "Primary Contact",
  [RolesEnum.CorpAdminDelegate]: "Corporate Admin Delegate",
  [RolesEnum.CollegeAdminDelegate]: "College Admin Delegate",
  [RolesEnum.SMC]: "SMC",
  [RolesEnum.KeyCompanyContact]: "Key Company Contact",
  [RolesEnum.Client]: "Client",
  [RolesEnum.KeyCompanyContactDelegate]: "Key Company Contact Delegate",
};

export const DELEGATE_ROLES: Record<DelegateRolesEnum, string> = {
  [RolesEnum.CorpAdminDelegate]: "Corporate Admin Delegate",
  [RolesEnum.CollegeAdminDelegate]: "College Admin Delegate",
  [RolesEnum.KeyCompanyContactDelegate]: "Key Company Contact Delegate",
};
